import { Component } from '@angular/core';
import { DataHelper } from '@app/helpers/data.helper';
import { TranslateService } from '@services/translate.service';
import { DimmerService } from '@app/services/dimmer.service';
import { LocalizationService } from '@app/services/localization.service';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'bet-settings',
  templateUrl: '../sharedTemplates/bet-settings.component.html',
})
export class BetSettingsComponent {
  betButtonAble = false;
  stakeButtonAble = false;

  constructor(
    public _UiHelper: UiHelper,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public _DimmerService: DimmerService,
    public _DataHelper: DataHelper
  ) {
    this.loadUserBetSettings();
  }

  saveStakeAmount() {
    localStorage.setItem('savedStakeAmount', JSON.stringify(this._DataHelper.default_stake_amount.amount_value.toString()));
    this.stakeButtonAble = true;
    this._DataHelper.currentSlipInfo.currentslip_totalStake = JSON.parse(localStorage.getItem('savedStakeAmount'));
    const t_message = this._TranslateService.instant('Proccessing_Successful');
    this._UiHelper.successSnackBar(t_message, '');
    this._DimmerService.clearActiveModalId();
  }
  saveBetAmounts() {
    localStorage.setItem('betAmounts', JSON.stringify(this._DataHelper.default_amount_arr));
    const t_message = this._TranslateService.instant('Proccessing_Successful');
    this._UiHelper.successSnackBar(t_message, '');
    this._DimmerService.clearActiveModalId();
  }
  loadUserBetSettings() {
    if (Number(localStorage.getItem('oddFormatId'))) {
      this._UiHelper.customerSelectedOddFormatTypeId = Number(localStorage.getItem('oddFormatId'));
    }
    const savedAmounts = JSON.parse(localStorage.getItem('betAmounts'));
    if (savedAmounts) {
      this._DataHelper.default_amount_arr = savedAmounts;
      this.betButtonAble = false;
    }
    const savedStakeAmount = JSON.parse(localStorage.getItem('savedStakeAmount'));
    if (savedStakeAmount) {
      this._DataHelper.default_stake_amount.amount_value = parseFloat(savedStakeAmount);
      this.stakeButtonAble = false;
    }
  }

  setBetAmount(value: string, amountId: number) {
    const normalizedValue = value.replace(',', '.');
    const amount = parseFloat(normalizedValue);
    const validAmount = Math.round(amount * 100) / 100;
    if (!isNaN(validAmount) && validAmount >= 1) {
      const amountIndex = this._DataHelper.default_amount_arr.findIndex(item => item.amount_id === amountId);
      if (amountIndex !== -1) {
        this._DataHelper.default_amount_arr[amountIndex].amount_value = validAmount;
        this.betButtonAble = true;
      }
    } else {
      this.betButtonAble = false;
    }
  }
  setStakeAmount(value: string) {
    const normalizedValue = value.replace(',', '.');
    let amount = parseFloat(normalizedValue);
    const validAmount = Math.round(amount * 100) / 100;
    if (!isNaN(validAmount) && validAmount >= 1) {
      this._DataHelper.default_stake_amount.amount_value = validAmount;
      this.stakeButtonAble = true;
    } else {
      this.stakeButtonAble = false;
    }
  }
  selectFormatType(changes: any): void {
    if (changes?.target?.value) {
      this._UiHelper.selectedFormatType(changes.target.value);
    }
  }
}
